import React from 'react'
import { useModalContext } from '@sketch/components'
import { WorkspaceMinimalFragment } from '@sketch/gql-types'

import { MountHandle } from '@sketch/utils'
import { Redirect, Route, RouteProps } from 'react-router'
import { routes } from '@sketch/modules-common'
import { OnlyWorkspaceAdmins } from '../../modals'

interface RestrictedWorkspaceSettingsRouteProps extends RouteProps {
  canAccess: boolean
  workspace: WorkspaceMinimalFragment
}

export const RestrictedWorkspaceSettingsRoute: React.FCC<
  RestrictedWorkspaceSettingsRouteProps
> = props => {
  const { canAccess, workspace, ...routeProps } = props

  const { showModal } = useModalContext()

  if (!canAccess) {
    return (
      <>
        <Redirect
          to={routes.WORKSPACE_SETTINGS_PEOPLE.create({
            workspaceId: workspace.identifier,
          })}
        />
        <MountHandle
          onMount={() =>
            showModal(
              OnlyWorkspaceAdmins,
              { name: workspace.name },
              { closeOnRouteChange: false }
            )
          }
        />
      </>
    )
  }

  return <Route {...routeProps} />
}
